export default __webpack_public_path__ + "static/hero-laurel.a6079211.svg";